/**
 * @deprecated Use `notify` from `components/ui/toaster` instead.
 *
 * Thin shim kept so existing call sites continue to work during migration.
 * `showToast({status})` forwards to the canonical `notify({type})` API.
 */

import { notify, type NotifyType } from "../components/ui/toaster";

interface ToastOptions {
  title: string;
  description?: string;
  status: NotifyType;
}

export const showToast = ({ title, description, status }: ToastOptions) => {
  notify({ title, description, type: status });
};
